import Keycloak from 'keycloak-js';


let config = window.config

const keycloak = new Keycloak({
	url: config.authServer.baseUrl,
	realm: config.authServer.realm,
	clientId: config.authServer.clientId
});

// Инициализировать Keycloak JS Adapter
keycloak.init({
	onLoad: 'check-sso',/**/
	silentCheckSsoRedirectUri: `${config.app.baseUrl}/silent-check-sso.html`,
	checkLoginIframe: false,
	scope: "offline_access"
}).then((auth) => {
	if (auth) {
		console.log("Authenticated");
		storeTokens(keycloak)

		setInterval(() => {
			console.log('Token is updating')
			// Обновляем токен, если срок его действия истекает в течении 300 секунд
			keycloak.updateToken(300)
				.then((refreshed) => {
					if (refreshed) {
						storeTokens(keycloak)
						console.log('Token refreshed' + refreshed);
					}
				})
				.catch(() => {
					console.error('Failed to refresh token');
					logout()
				});
		}, 60000)
	} else {
		console.log('Not authenticated')
	}
}).catch(() => {
	console.error("Authenticated Failed");
});

function getConfig() {
	return config
}

async function getRedirectUrl() {
	const url = getConfig().authServer.baseUrl + getConfig().authServer.authorizePath;
	const params = new URLSearchParams({
		response_type: 'code',
		client_id: getConfig().authServer.clientId,
		code_challenge_method: 'S256',
		code_challenge: await generateCodeChallenge(getCodeVerifier()),
		redirect_uri: getConfig().app.baseUrl + getConfig().app.afterAuthorizeRedirectPath,
		scope: 'openid roles',
	});
	return url + '?' + params;
}

async function requestTokens(code) {
	const url = getConfig().authServer.baseUrl + getConfig().authServer.tokenPath;
	const options = {
		method: 'POST',
		headers: { 'content-type': 'application/x-www-form-urlencoded' },
		body: new URLSearchParams({
			grant_type: 'authorization_code',
			client_id: getConfig().authServer.clientId,
			code_verifier: getCodeVerifier(),
			code: code,
			redirect_uri: getConfig().app.baseUrl + getConfig().app.afterAuthorizeRedirectPath,
		})
	};
	console.log(options)
	console.log(url)
	const res = await fetch(url, options);
	if (res.status === 200) {
		const data = await res.json();
		return data;
	} else {
		throw new Error('Ошибка получения токенов');
	}
}

async function refreshTokens(refreshToken) {
	const url = getConfig().authServer.baseUrl + getConfig().authServer.tokenPath;
	const options = {
		method: 'POST',
		headers: { 'content-type': 'application/x-www-form-urlencoded' },
		body: new URLSearchParams({
			grant_type: 'refresh_token',
			client_id: getConfig().authServer.clientId,
			code_verifier: getCodeVerifier(),
			refresh_token: refreshToken,
			redirect_uri: getConfig().app.baseUrl + getConfig().app.afterAuthorizeRedirectPath,
		})
	};
	const res = await fetch(url, options);
	if (res.status === 200) {
		const data = await res.json();
		return data;
	} else {
		throw new Error('Ошибка обновления токенов');
	}
}

function getLogoutUrl(afterLogoutRedirectPath) {
	if (!afterLogoutRedirectPath) {
		afterLogoutRedirectPath = getConfig().app.afterLogoutRedirectPath;
	}

	const url = getConfig().authServer.baseUrl + getConfig().authServer.logoutPath;
	const params = new URLSearchParams({
		post_logout_redirect_uri: encodeURI(getConfig().app.baseUrl + afterLogoutRedirectPath),
		id_token_hint: getIdToken(),
	});
	return url + '?' + params;
}

async function authorize(code, href = '/') {
	const tokens = await requestTokens(code);
	console.log(tokens);
	storeTokens(tokens);
	const role = getUserRole()
	if (authorizedThroughEsia() && role === 'user') {
		window.location.href = '/send';
	} else {
		window.location.href = getConfig().basePath + href;
	}
}

async function refresh() {
	try {
		await keycloak.updateToken(300);
	} catch (error) {
		console.error('Failed to refresh token:', error);
		logout()
	}/*
	const tokens = await refreshTokens(getRefreshToken());
	console.log(tokens);
	storeTokens(tokens);*/
}

function logout() {
	const url = getLogoutUrl()
	deleteTokens();
	window.location.href = url;
}

function authorized() {
	return getAccessToken() !== undefined && getAccessToken() !== null;
}

function authorizedThroughEsia() {
	if (!authorized()) {
		return false;
	}

	const token = getAccessToken();
	const fields = parseJwt(token);
	const trusted = fields?.esia?.trusted;
	console.log('trusted', trusted);
	return (typeof trusted !== 'undefined' && trusted !== null) ? true : false;
}

function getAccessToken() {
	return window.localStorage.getItem("access_token");
}

function getRefreshToken() {
	return window.localStorage.getItem("refresh_token");
}

function getIdToken() {
	return window.localStorage.getItem("id_token");
}

function storeTokens(tokens) {
	if (tokens.access_token || tokens.token) {
		storeAccessToken(tokens.access_token ?? tokens.token);
	}
	if (tokens.refresh_token || tokens.refreshToken) {
		storeRefreshToken(tokens.refresh_token ?? tokens.refreshToken);
	}
	if (tokens.id_token || tokens.idToken) {
		storeIdToken(tokens.id_token ?? tokens.idToken);
	}
}

function storeAccessToken(token) {
	window.localStorage.setItem("access_token", token);
}

function storeRefreshToken(token) {
	window.localStorage.setItem("refresh_token", token);
}

function storeIdToken(token) {
	window.localStorage.setItem("id_token", token);
}

function deleteTokens() {
	window.localStorage.removeItem("access_token");
	window.localStorage.removeItem("refresh_token");
	window.localStorage.removeItem("id_token");
}

function generateCodeVerifier() {
	const length = 64;
	let text = "";
	const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

	for (var i = 0; i < length; i++) {
		text += possible.charAt(Math.floor(Math.random() * possible.length));
	}

	return text;
}

async function generateCodeChallenge(codeVerifier) {
	const digest = await crypto.subtle.digest("SHA-256",
		new TextEncoder().encode(codeVerifier));

	return btoa(String.fromCharCode(...new Uint8Array(digest)))
		.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

function getCodeVerifier() {
	let codeVerifier = window.localStorage.getItem("codeVerifier");
	if (!codeVerifier) {
		codeVerifier = generateCodeVerifier();
		window.localStorage.setItem("codeVerifier", codeVerifier);
	}
	return codeVerifier;
}

function parseJwt(token) {
	if (!token) return {}

	const base64Url = token.split('.')[1];
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	return JSON.parse(jsonPayload);
}

function getFields() {
	return parseJwt(getAccessToken());
}

function getUsername() {
	const token = getAccessToken();
	const fields = parseJwt(token);
	console.log(fields);
	return fields.preferred_username;
}

function getRoles() {
	if (!authorized()) return []

	const token = getAccessToken();
	const fields = parseJwt(token);

	return fields?.realm_access?.roles ?? [];
}

function getFullName() {
	if (!authorized()) return ''

	const token = getAccessToken();
	const fields = parseJwt(token);

	return `${fields?.family_name ?? ''} ${fields?.given_name ?? ''} ${fields?.middle_name ?? ''}`.trim();
}

function getUserRole() {
	const roles = getRoles()

	if (roles.includes('admin')) return 'admin'
	if (roles.includes('registrar')) return 'registrar'

	if (authorized()) return 'user'

	return 'guest'
}

async function requestAppeals(url, start_date, end_date, filters) {
	url = url ?? getConfig().appealsRegistrarUrl;
	const options = {
		method: 'GET',
		headers: {
			'Authorization': 'Bearer ' + getAccessToken(),
		},
	};

	let filtersParams = ''
	if (filters.sender !== '') filtersParams += `&filter[created_by_registrar]=${filters.sender}`
	if (filters.addressee !== '') filtersParams += `&filter[zone_id]=${filters.addressee}`
	if (filters.uid !== '') filtersParams += `&filter[uid]=${filters.uid}`
	if (filters.full_name !== '') filtersParams += `&filter[full_name]=${filters.full_name}`
	if (filters.theme !== '') filtersParams += `&filter[theme]=${filters.theme}`

	const res = await fetch(`${url}?filter[start_date]=${start_date}&filter[end_date]=${end_date}${filtersParams}`, options);
	if (res.status === 200) {
		const data = await res.json();
		return data;
	}

	if (res.status === 401 || res.status === 403) {
		if (res.status === 401) {
			await refresh()
			//location.href = window.location.pathname
		}
		const data = await res.json();
		throw new Error(data.error);
	}

	throw new Error('Ошибка получения обращений');
}

async function requestAppealsCounts(start_date, end_date) {
	let url = getConfig().appealsCounts;
	const options = {
		method: 'GET',
		headers: {
			'Authorization': 'Bearer ' + getAccessToken(),
		},
	};
	const res = await fetch(`${url}?filter[start_date]=${start_date}&filter[end_date]=${end_date}`, options);

	if (res.status === 200) {
		const data = await res.json();
		return data;
	}

	if (res.status === 401 || res.status === 403) {
		if (res.status === 401) {
			await refresh()
		}
		const data = await res.json();
		throw new Error(data.error);
	}

	throw new Error('Ошибка получения обращений');
}

const registration = async (body) => {
	const url = getConfig().authServer.baseUrl + getConfig().authServer.registration;
	let res = await fetch(url, {
		method: "POST",
		accept: "application/json",
		body,
	})

	if (res.status === 200) {
		const data = await res.json();
		return data;
	}

	throw new Error('Ошибка регистрации ' + res.statusText);
}

export {
	getConfig,
	getRedirectUrl,
	requestTokens,
	refreshTokens,
	getLogoutUrl,
	authorize,
	refresh,
	logout,
	authorized,
	getAccessToken,
	getRefreshToken,
	storeTokens,
	storeAccessToken,
	storeRefreshToken,
	storeIdToken,
	deleteTokens,
	generateCodeVerifier,
	generateCodeChallenge,
	getCodeVerifier,
	parseJwt,
	getUsername,
	getRoles,
	getUserRole,
	getFullName,
	requestAppeals,
	requestAppealsCounts,
	registration,
	authorizedThroughEsia,
	getFields,
}